import store from '@/core/store'
import { getBoxesLabels, setBoxLabelVisibility, createBoxLabel, changeBoxLabelName, deleteBoxLabel, changeBoxLabelIndex } from '@/app-domains/labels/api/labels.api'
import { addBoxLabel, toggleLabelVisibility, changeLabelName, removeLabel } from '@/core/store/Slices/BoxLabelsSlice'
import containersService from '../../services/containers.service'
import threadsService from '../threads/threads.service'
import boxesService from '../boxes/boxes.service'
import { updateUnlabeledVisibility } from '@/core/http/me.api'
import sessionService from '../user/session/session.service'

class LabelsService {
  async getLabels () {
    const labels = await getBoxesLabels()
    labels.results.forEach((label) => {
      this.storeLabel(label)
    })
    containersService.generateContainersMap()
  }

  storeLabel (label) {
    store.dispatch(addBoxLabel(label))
  }

  async createBoxLabel (labelData) {
    const res = await createBoxLabel(labelData)
    this.storeLabel(res.data)
    containersService.generateContainersMap()
    store.commit('LABELS:UPDATED')
    return res.data
  }

  async deleteLabel (labelId) {
    await deleteBoxLabel(labelId)
    store.dispatch(removeLabel({ labelId }))
    containersService.generateContainersMap()

    // Update affected boxes due deletion
    const boxes = boxesService.getRawBoxesForLabel(labelId)
    for (const box of boxes) {
      const labels = this.findLabelsForBox(box)
      boxesService.editBoxLabelsForBox(box, labels)
    }

    containersService.generateContainersMap()
    store.commit('LABELS:DELETED')
  }

  async updateLabelName (label, labelName) {
    await changeBoxLabelName({
      labelId: label.composedid,
      labelName
    })
    store.dispatch(changeLabelName({
      labelId: label.id,
      labelName
    }))
    containersService.generateContainersMap()
    store.commit('LABELS:UPDATED')
  }

  findLabelById (labelId) {
    return Object.values(this.getLabelsFromStore())
      .find(label => label.composedid === labelId)
  }

  findLabelsByQuery (query) {
    const labels = this.getLabelsFromStore()
    const labelsFiltered = Object.values(labels)?.filter(label => label?.name?.includes(query))
    return labelsFiltered
  }

  getLabelsFromStore () {
    return store.getState().boxlabels.labels
  }

  getLabelsFromContainersMap (containersMap) {
    const labelsArray = []
    for (const labelKey in containersMap) {
      const label = containersMap[labelKey]
      labelsArray.push(label)
    }
    return labelsArray
  }

  getLabelsList () {
    const containersMap = containersService.getContainersMap()
    const labelsArray = this.getLabelsFromContainersMap(containersMap)

    return labelsArray
      .filter(label => label.role !== 'system')
      .sort(this.sortLabelsWithDefaultLabelAsFirstItem)
  }

  getPureLabelsList () {
    return this.getLabelsList().filter(label => label.role !== 'default')
  }

  sortLabelsWithDefaultLabelAsFirstItem (a) {
    return a.role === 'default' ? -1 : 0
  }

  async hideLabelFromMainFeed (label) {
    const hideLabel = label.showninfeed
    store.dispatch(
      toggleLabelVisibility(label)
    )
    containersService.generateContainersMap()

    store.commit('THREADS:UPDATED')
    store.commit('LABELS:UPDATED')
    if (label.type === 'no-labeled') {
      await updateUnlabeledVisibility(!label.isShown)
    } else {
      await setBoxLabelVisibility(label.composedid, hideLabel)
    }

    await sessionService.setMeInfo()
    containersService.generateContainersMap()
    threadsService.queryLastThreads()
  }

  findLabelsForBox (box) {
    const boxLabels = box.boxlabels
    if (!boxLabels || boxLabels.length === 0) { return [] }
    const labelList = this.getLabelsList()
    const labelsFound = labelList.filter(
      (label) => boxLabels.filter(
        (bl) => bl.composedid === label.composedid
      )?.length > 0
    )
    return labelsFound
  }

  async resortLabelToIndex (label, index) {
    const composedId = label.composedid
    await changeBoxLabelIndex({
      labelId: composedId,
      index
    })
    this.getLabels()
  }
}

export default new LabelsService()
